module.exports = __webpack_public_path__ + "img/agriculture-careers.1b738964.jpg";